import type { RootState } from 'state';

function isSearchEnabled(state: RootState): boolean {
  const { airportsFrom, airportsTo, month } = state.flightCalendars.filtersValues;
  return airportsFrom.length > 0 && airportsTo.length > 0 && month !== null;
}

export default isSearchEnabled;
